import { useRouter } from 'next/router'
import FaqPage from '../components/faq/FaqPage'
import FaqNew from '../components/pages-new/FaqNew'

import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const FaqLocalPageOld = () => {
  return (
    <FaqPage
      type="local"
      title="FAQ คำถามที่พบบ่อย - ส่งกี่วันถึง ประกันยังไง ขนส่งหยุดวันไหน"
      keywords="ส่งกี่วัน, การเคลม, วันหยุดขนส่ง, พื้นที่ห่างไกล"
      description="รวบรวมคำถามที่พบบ่อย เกี่ยวกับการใช้งานขนส่ง และ เงื่อนไข วันหยุด การรับประกัน การเคลม พื้นที่ห่างไกล ทุกขนส่ง"
    />
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'faq',
    ])),
  },
})

// ?new → new-design variant (new chrome, same content); otherwise the old
// page renders unchanged. Wrapper keeps hook order stable across both paths
// (each branch is its own component, so neither shares the other's hooks).
const FaqLocalPage = (props) => {
  const { query } = useRouter()
  if ('old' in query) return <FaqLocalPageOld {...props} />
  return (
    <FaqNew
      {...props}
      type="local"
      title="FAQ คำถามที่พบบ่อย - ส่งกี่วันถึง ประกันยังไง ขนส่งหยุดวันไหน"
      keywords="ส่งกี่วัน, การเคลม, วันหยุดขนส่ง, พื้นที่ห่างไกล"
      description="รวบรวมคำถามที่พบบ่อย เกี่ยวกับการใช้งานขนส่ง และ เงื่อนไข วันหยุด การรับประกัน การเคลม พื้นที่ห่างไกล ทุกขนส่ง"
    />
  )
}

export default FaqLocalPage
